export const navShow = state => state.navShow
export const isShow = state => state.isShow
export const imgUrl = state => state.imgUrl



// WEBPACK FOOTER //
// ./src/store/getters.js